import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {

  @Input() src: any;
  @Input() full: any;
  constructor() { }

  ngOnInit(): void {
    // this.src = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  }

  downloadPdf() {
    const link = document.createElement('a');
    link.href = this.src;
    link.download = 'preview.pdf';
    link.click();
  }
}
